import React, { Component } from "react";

class JobFailed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printer: props.printer,
    };
  }

  render() {
    // const { failedJob } = this.props;
    const pricing = this.state.printer.state.computerUser.pricing;

    return (
      <div
        id="menu-job-failed"
        className="menu menu-box-bottom"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        <div className="top-20">
          <h2 className="uppercase bold">Job failed</h2>
          <p className="under-heading bottom-20">Your job did not finish</p>
          <div className="center-text-huge bottom-0 error-message">
            {pricing && <div>You were not charged</div>}
            <div>Please try again later</div>
          </div>
          <a
            href="#"
            className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight"
          >
            Close
          </a>
        </div>
      </div>
    );
  }
}

export default JobFailed;



// WEBPACK FOOTER //
// ./src/components/pages/printer/jobFailed.js